/**
 * AppBridgeProvider — currently a pass-through component.
 *
 * In @shopify/app-bridge-react v4.2+, Shopify Admin automatically injects
 * the App Bridge script into the embedded app iframe. No Provider configuration
 * is needed — the `shopify` global is available on `window` / `globalThis`.
 *
 * Session tokens are obtained via `globalThis.shopify.idToken()` in api.ts.
 *
 * This wrapper exists as a future extension point (e.g. for navigation
 * interception, toast providers, etc.).
 */
export function AppBridgeProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>): React.ReactElement {
  return <>{children}</>;
}
